import { combineReducers } from 'redux';
import smallAreas from './small-areas';
import localElectoral from './local-electoral';
import gardaSubdivision from './garda-subdivision';
import airBnb from './airbnb';
import propertySales from './property-sales';
import noise from './noise';
 
const allReducers =  combineReducers({
  sa: smallAreas,
  lea: localElectoral,
  crime: gardaSubdivision,
  airbnb: airBnb,
  properties: propertySales,
  noise: noise
})

export default allReducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js